import {
  DailymotionPlatform,
  FacebookPlatform,
  SocialPlatform,
  YoutubePlatform,
} from '@app/modules/social-export/domain/platforms';
import { DailymotionConnect } from '../../../platforms/dailymotion/connect/DailymotionConnect';
import { FacebookConnect } from '../../../platforms/facebook/connect/FacebookConnect';
import { YoutubeConnect } from '../../../platforms/youtube/connect/YoutubeConnect';
import { DefaultPlatformConnect } from '../DefaultPlatformConnect';

type Props = {
  platform: SocialPlatform;
  stationId: string;
};

export function PlatformConnectFactory({ platform, stationId }: Props) {
  if (platform === DailymotionPlatform) {
    return <DailymotionConnect stationId={stationId} />;
  }

  if (platform === FacebookPlatform) {
    return <FacebookConnect stationId={stationId} />;
  }

  if (platform === YoutubePlatform) {
    return <YoutubeConnect stationId={stationId} />;
  }

  return <DefaultPlatformConnect platform={platform} stationId={stationId} />;
}
